import React from 'react';
import { Link } from 'react-router-dom';
import { Rocket, Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <img 
                src="/procloud-logo.png" 
                alt="ProCloud Promotional" 
                className="h-16 w-auto bg-white rounded-lg p-2"
              />
            </Link>
            <p className="text-sm mb-4">
              Your ultimate destination for premium promotional products. We help your brand stand out with quality merchandise.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-pink-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/products/all" className="hover:text-pink-400 transition-colors">
                  All Products
                </Link>
              </li>
              <li>
                <Link to="/quote-cart" className="hover:text-pink-400 transition-colors">
                  Request Quote
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-pink-400 transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Product Categories */}
          <div>
            <h4 className="text-white font-semibold mb-4">Categories</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/products/writing-instruments" className="hover:text-pink-400 transition-colors">
                  Writing Instruments
                </Link>
              </li>
              <li>
                <Link to="/products/drinkware" className="hover:text-pink-400 transition-colors">
                  Drinkware
                </Link>
              </li>
              <li>
                <Link to="/products/technology" className="hover:text-pink-400 transition-colors">
                  Technology
                </Link>
              </li>
              <li>
                <Link to="/products/eco-products" className="hover:text-pink-400 transition-colors">
                  Eco Products
                </Link>
              </li>
              <li>
                <Link to="/products/apparel" className="hover:text-pink-400 transition-colors">
                  Apparel
                </Link>
              </li>
              <li>
                <Link to="/products/bags" className="hover:text-pink-400 transition-colors">
                  Bags
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Mission Control</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Phone className="h-4 w-4 mt-1 flex-shrink-0" />
                <span>1300 722 659</span>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="h-4 w-4 mt-1 flex-shrink-0" />
                <span>info@procloud.com.au</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 mt-1 flex-shrink-0" />
                <span>Unit 10, 193 South Pine Road<br />Brendale QLD 4500</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm">
          <p>&copy; 2025 ProCloud Promotional. All rights reserved.</p>
          <p className="mt-2 text-gray-500">
            Powered by ProCloud Creative - Branding, Signage & Promotional Products
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
